import { css } from '@emotion/react';
import type { ComponentPropsWithoutRef, ForwardedRef } from 'react';
import { forwardRef } from 'react';

export function lineClampStyle(lines = 1) {
	return css(
		lines === 1
			? {
					// workaround when only one line is required
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				}
			: {
					// line-clamp is not standardized yet so we must use the webkit prefix.
					// See https://css-tricks.com/almanac/properties/l/line-clamp/#so-whats-the-catch
					display: '-webkit-box',
					WebkitLineClamp: lines,
					WebkitBoxOrient: 'vertical',
					overflow: 'hidden',
				}
	);
}

export interface LineClampProps extends ComponentPropsWithoutRef<'div'> {
	/**
	 * The maximum number of lines allowed.
	 *
	 * @default 1
	 */
	lines?: number;
}

/**
 * Limit the number of lines a block of text can have.
 *
 * This is a replacement for `Truncate` from react-truncate.
 */
export const LineClamp = forwardRef(function LineClampRender(
	{ lines = 1, ...props }: LineClampProps,
	ref: ForwardedRef<HTMLDivElement>
) {
	return <div css={lineClampStyle(lines)} {...props} ref={ref} />;
});
